import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLaravelhorizonComponent } from './simple-icons-laravelhorizon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLaravelhorizonComponent ],
    exports:      [ SimpleIconsLaravelhorizonComponent ],
    bootstrap:    []
})
export class SimpleIconsLaravelhorizonModule {}
